/*LIBRARY*/
import React, { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import EDIT_FOLDER_PROJECT from "./EDIT_FOLDER_PROJECT";
import DELETE_FOLDER_PROJECT from "./DELETE_FOLDER_PROJECT";
import MOVE_FOLDER_TO_FOLDER from "./MOVE_FOLDER_TO_FOLDER";
import FOLDER_COLLAB from "./FOLDER_COLLAB";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import {
  push_value_project,
  set_value_project,
} from "../../App/actions/projectActions";
import {
  get_folder_list_by_parent_folder_id,
  get_project_list_by_folder_id,
} from "../../App/actions/folderProjectAction";

/*PICTURE*/

/*FUNCTION*/
import format_date_short from "../../App/validation/format_date_short";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const FOLDER_PROJECT_MODE_LIST = ({
  auth,
  project,
  push_value_project,
  set_value_project,
  get_folder_list_by_parent_folder_id,
  get_project_list_by_folder_id,
}) => {
  //local state
  const [modal_menu, set_modal_menu] = useState(false);
  const [anchor, set_anchor] = useState(null);
  const [folder_id, set_folder_id] = useState("");
  const [folder, set_folder] = useState({});
  const [modal_edit_folder, set_modal_edit_folder] = useState(false);
  const [modal_delete_folder, set_modal_delete_folder] = useState(false);
  const [modal_move_folder, set_modal_move_folder] = useState(false);
  const [modal_folder_collab, set_modal_folder_collab] = useState(false);

  //global props
  const {
    folder_project_list,
    folder_project_child_list,
    folder_id_selected_list,
    folder_object_selected_list,
    loading_item_array,
  } = project;

  const on_click_folder = (selected_folder) => {
    set_value_project({
      key: "folder_project_child_list",
      value: [],
    });
    set_value_project({
      key: "geo_project_list_child",
      value: [],
    });

    const current_folder_id = selected_folder?._id;
    set_value_project({
      key: "folder_id_selected",
      value: current_folder_id,
    });
    set_value_project({
      key: "folder_object_selected",
      value: selected_folder,
    });
    push_value_project({
      key: "folder_object_selected_list",
      value: selected_folder,
    });
    push_value_project({
      key: "folder_id_selected_list",
      value: current_folder_id,
    });
    get_folder_list_by_parent_folder_id({
      folder_parent_id: current_folder_id,
    });
    get_project_list_by_folder_id({
      folder_id: current_folder_id,
    });
  };

  const toggle_move_folder = () => {
    set_modal_move_folder(!modal_move_folder);
    set_modal_menu(false);
  };

  const toggle_edit_folder = () => {
    set_modal_edit_folder(!modal_edit_folder);
    set_modal_menu(false);
  };

  const toggle_delete_folder = () => {
    set_modal_delete_folder(!modal_delete_folder);
    set_modal_menu(false);
  };

  const toggle_menu = (event) => {
    if (event) {
      let folder_final_list =
        folder_object_selected_list.length > 0
          ? folder_project_child_list
          : folder_project_list;
      const target_id = event?.target?.id;
      const selected_folder = folder_final_list.find(
        (item) => item?._id === target_id,
      );
      set_value_project({
        key: "folder_id_selected_collab",
        value: target_id,
      });
      set_modal_menu(true);
      set_anchor(event.currentTarget);
      set_folder_id(target_id);
      set_folder(selected_folder || {});
    } else {
      set_modal_menu(false);
      set_anchor(null);
      set_folder_id("");
      set_folder({});
      set_value_project({
        key: "folder_id_selected_collab",
        value: "",
      });
    }
  };

  const toggle_folder_collab = () => {
    set_modal_folder_collab(!modal_folder_collab);
    set_modal_menu(false);
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //content
  let folder_list_final = [];
  if (folder_id_selected_list.length === 0) {
    folder_list_final = folder_project_list;
  } else {
    folder_list_final = folder_project_child_list;
  }

  const modal_menu_content = modal_menu && (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={() => toggle_menu()}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      style={{ borderRadius: "15px" }}
    >
      <div>
        <button
          type="button"
          className="button margin_bottom button_white"
          onClick={toggle_move_folder}
        >
          {dict?.["Move to folder"]?.[language]}
        </button>
        <br />
        <button
          type="button"
          className="button margin_bottom button_white"
          onClick={toggle_edit_folder}
        >
          {dict?.["Edit"]?.[language]}
        </button>
        <br />
        <button
          type="button"
          className="button margin_bottom button_white"
          onClick={toggle_folder_collab}
        >
          {dict?.["Collaboration"]?.[language]}
        </button>
        <br />
        <button
          type="button"
          className="button button_white"
          onClick={toggle_delete_folder}
        >
          {dict?.["Delete"]?.[language]}
        </button>
      </div>
    </FLOAT_MENU>
  );

  const modal_edit_folder_content = modal_edit_folder && (
    <Modal
      modalSize="small"
      isOpen={modal_edit_folder}
      onClose={toggle_edit_folder}
    >
      <div className="box-body" id="box-body">
        <EDIT_FOLDER_PROJECT
          folder={folder}
          toggle_edit_folder={toggle_edit_folder}
        />
      </div>
    </Modal>
  );

  const modal_delete_folder_content = modal_delete_folder && (
    <Modal
      modalSize="small"
      isOpen={modal_delete_folder}
      onClose={toggle_delete_folder}
    >
      <div className="box-body" id="box-body">
        <DELETE_FOLDER_PROJECT
          folder={folder}
          toggle_delete_folder={toggle_delete_folder}
        />
      </div>
    </Modal>
  );

  const modal_move_folder_content = modal_move_folder && (
    <Modal
      modalSize="medium"
      isOpen={modal_move_folder}
      onClose={toggle_move_folder}
      title={dict?.["Move to folder"]?.[language]}
    >
      <div className="box-body" id="box-body">
        <MOVE_FOLDER_TO_FOLDER
          folder={folder}
          toggle_move_folder={toggle_move_folder}
        />
      </div>
    </Modal>
  );

  const modal_folder_collab_content = modal_folder_collab && (
    <Modal
      modalSize="medium"
      isOpen={modal_folder_collab}
      onClose={toggle_folder_collab}
    >
      <div className="box-body">
        <FOLDER_COLLAB />
      </div>
    </Modal>
  );

  let list_content;

  if (loading_item_array.includes("get_folder_list_by_parent_folder_id")) {
    list_content = (
      <div className="container_light">{dict?.["Load"]?.[language]}...</div>
    );
  } else if (folder_list_final.length === 0) {
    list_content = (
      <section
        className="container background_white"
        style={{ height: "100px", width: "200px" }}
      >
        <p className="text_medium sub_color">
          {dict?.["You don't have a folder yet"]?.[language]}
        </p>
      </section>
    );
  } else {
    list_content = (
      <div
        className="background_white outline_grey"
        style={{ borderRadius: "8px", overflow: "hidden" }}
      >
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "600px",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #e9ecef",
                }}
              >
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "150px",
                  }}
                >
                  {dict?.["Name"]?.[language]}
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "100px",
                  }}
                >
                  {dict?.["Created"]?.[language]}
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "100px",
                  }}
                >
                  {dict?.["Modified"]?.[language]}
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "600",
                    width: "50px",
                    minWidth: "50px",
                  }}
                ></th>
              </tr>
            </thead>
            <tbody>
              {folder_list_final.map((folder_item, idx) => {
                const date_created = folder_item?.date_created
                  ? format_date_short(folder_item.date_created)
                  : "";
                const date_modified = folder_item?.date_modified
                  ? format_date_short(folder_item.date_modified)
                  : "";
                const name_original = folder_item?.name;
                let name = folder_item?.name || "";

                if (name.length > 70) {
                  const limit = 20;
                  const first = name?.slice(0, limit);
                  const last = name?.slice(name.length - limit, name.length);
                  name = first + "..." + last;
                }

                return (
                  <tr
                    key={folder_item?._id || idx}
                    style={{
                      borderBottom: "1px solid #e9ecef",
                      backgroundColor:
                        folder_item._id === folder_id
                          ? "#e3f2fd"
                          : idx % 2 === 0
                            ? "#fff"
                            : "#fafafa",
                    }}
                  >
                    {/* Name Column */}
                    <td
                      onClick={() => on_click_folder(folder_item)}
                      style={{ padding: "12px 16px", cursor: "pointer" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p
                          className="text_bold"
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={name_original}
                        >
                          {name}
                        </p>
                        {folder_item?.groups?.length > 0 && (
                          <div
                            className="badge_small background_black margin_left"
                            style={{
                              verticalAlign: "middle",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {dict?.["Group"]?.[language]}
                          </div>
                        )}
                      </div>
                    </td>

                    {/* Created Date Column */}
                    <td style={{ padding: "12px 16px" }}>
                      <p
                        className="text_small"
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {date_created || "-"}
                      </p>
                    </td>

                    {/* Modified Date Column */}
                    <td style={{ padding: "12px 16px" }}>
                      <p
                        className="text_small"
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {date_modified || "-"}
                      </p>
                    </td>

                    {/* Actions / Menu Column */}
                    <td style={{ padding: "12px 16px", textAlign: "center" }}>
                      <button
                        type="button"
                        onClick={toggle_menu}
                        id={folder_item._id}
                        className="button_small button_white"
                        style={{ padding: "4px 8px", minWidth: "30px" }}
                      >
                        ⫶
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <main className="margin_bottom">
      {modal_move_folder_content}
      {modal_delete_folder_content}
      {modal_edit_folder_content}
      {modal_menu_content}
      {modal_folder_collab_content}
      <h3 className="text_big margin_bottom">
        {dict?.["Folders"]?.[language]}
      </h3>
      {list_content}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, {
  push_value_project,
  set_value_project,
  get_folder_list_by_parent_folder_id,
  get_project_list_by_folder_id,
})(FOLDER_PROJECT_MODE_LIST);
